export default "__VITE_ASSET__Ckk_Rk4O__"